<template>
	<div>
		<teleport to="#modal">
			<div class="modal_container">
				<div ref="modalEl" class="modal_box">
					<!-- 모달 콘텐츠 들어가는 부분 -->
					<div class="modal_content">
						<slot></slot>
					</div>
					<div class="buttonBox">
						<button @click="setCloseForToday">오늘 하루 안 보기</button>
						<button @click="emit('update:close')">닫기</button>
					</div>
				</div>
			</div>
		</teleport>
	</div>
</template>

<script setup lang="ts">
// core
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

const emit = defineEmits(['update:close']);
const route = useRoute();
const modalEl = ref();
const isShow = ref(true);

const getCookie = (name: string) => {
	const cookieString = document.cookie;
	const cookies = cookieString.split(';').map((cookie) => cookie.trim());

	for (const cookie of cookies) {
		const [cookieName, cookieValue] = cookie.split('=');
		if (cookieName === name) {
			return decodeURIComponent(cookieValue);
		}
	}

	return null;
};

const setCloseForToday = () => {
	const expDate = new Date();
	expDate.setDate(expDate.getDate() + 1);
	expDate.setHours(9, 0, 0, 0);

	const jsonStringFromCookie = getCookie('location');
	console.log('jsonStringFromCookie', jsonStringFromCookie);
	const additionalString = String(route.name);
	let locationArr = jsonStringFromCookie?.split(',');
	if (!locationArr) {
		locationArr = [additionalString];
		console.log('locationArr', locationArr);
	} else if (!locationArr?.includes(additionalString)) {
		locationArr?.push(additionalString);
	}
	const finalString = locationArr?.join(',');

	document.cookie = 'closeForToday' + '=' + 'true' + '; expires=' + expDate.toUTCString();
	document.cookie = 'location' + '=' + `${finalString}` + '; expires=' + expDate.toUTCString();
	isShow.value = false;
	emit('update:close');
};
//모달 외부 클릭시 모달 닫기
onClickOutside(modalEl, () => {
	emit('update:close');
});
</script>

<style scoped lang="scss">
.modal_container {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	width: 100%;
	height: 100dvh;
	background: rgba(0, 0, 0, 0.3);
	.modal_box {
		position: relative;
		width: 100%;
		border-top-right-radius: var(--border-radius-mid);
		border-top-left-radius: var(--border-radius-mid);

		.modal_content {
			overflow: hidden;
			overflow-y: auto;
			max-height: 75vh;
			border-top-right-radius: var(--border-radius-mid);
			border-top-left-radius: var(--border-radius-mid);
			:deep(.swiper-slide) {
				border-top-right-radius: var(--border-radius-mid);
				border-top-left-radius: var(--border-radius-mid);
				aspect-ratio: 42/48;

				cursor: pointer;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					object-position: center;
					background-color: var(--color-bg-light);
					overflow: hidden;
				}
			}
			:deep(.swiper-pagination) {
				bottom: 1.3rem;
				@media screen and (max-width: 768px) {
					bottom: 1rem;
				}
				.swiper-pagination-bullet {
					background-color: #7d7d8d;
					width: 1rem;
					height: 1rem;
					border-radius: var(--border-radius-full);
					transition: var(--transition-default);
					opacity: 1;
					&.swiper-pagination-bullet-active {
						background-color: #23242f;
					}
				}
			}
			/* padding: 0 calc(var(--space-large) - 8px);
			scrollbar-gutter: stable both-edges;
			&::-webkit-scrollbar {
				-webkit-appearance: none;
				width: 4px;
			}
			&::-webkit-scrollbar-track {
				background: transparent;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 100px;
				background-color: #ccc;
			} */
		}
		.buttonBox {
			display: flex;
			justify-content: center;
			align-items: center;
			color: var(--color-font-dark);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			button {
				flex: 1;
				white-space: nowrap;
				padding: 1.55rem;
				&:first-child {
					color: var(--color-base-dark);
					background-color: #fff;
				}
				&:last-child {
					background-color: var(--color-primary);
					color: var(--color-base-white);
				}
				@media screen and (max-width: 768px) {
					font-size: var(--font-size-mid);
				}
			}
		}
	}
}
</style>
